import { Component, OnInit, ViewChild } from '@angular/core';
import { LookupService } from '../../../services/lookups/lookup.service';
import { LookupAdminService } from '../../../services/lookups/lookupadmin.service';
import { Location } from '../../../models/user.model';
import { SelectItem  } from 'primeng/api';
import { PostDetailComponent } from './post-detail/post-detail.component';

@Component({
  selector: 'app-post',
  templateUrl: './post.component.html',
  styleUrls: ['./post.component.css']
})
export class PostComponent implements OnInit {
  posts: Location[];
  locationNames:SelectItem[];
  parentLocationNames:SelectItem[];
  isActiveList:SelectItem[];
  displayPostDetailDlg:boolean;
  @ViewChild(PostDetailComponent) postDetail: PostDetailComponent;
  constructor(private lookupService: LookupService, private lookupAdminService: LookupAdminService) {}

  ngOnInit() {
    this.LoadAllPosts();
    
  }

  private LoadAllPosts() {
    this.lookupAdminService.getAllPosts$().subscribe(data => {
      this.posts = data;
      this.posts.sort(
        (a, b): number => {
          if (a.locationName < b.locationName) return -1;
          if (a.locationName > b.locationName) return 1;
          return 0;
        }
      );
      this.locationNames = this.lookupAdminService.GetUniqueValues(this.posts.map(p=>p.locationName));
      this.parentLocationNames = this.lookupAdminService.GetUniqueValues(this.posts.map(p=>p.parentLocationName));
      var isActives = new Array<SelectItem>();
      isActives.push({ label: "Yes", value:true});
      isActives.push({ label: "No", value:false});
      this.isActiveList = isActives;
    });
  }
  
  ShowHidePostDetailDialog(isDisplay:boolean)
  {
    this.displayPostDetailDlg = isDisplay;
    //TODO: Add behaviour subject in the services to manage refresh of the table.
    //this.LoadAllPosts();
    
  }
  showPostDetailDialog(location:any)
  {
     this.postDetail.showPostDetailDialog(location);
    this.ShowHidePostDetailDialog(true);
  }
  RefreshDataSource(isReload:boolean)
  {
    if(isReload)
     this.LoadAllPosts();
  }


}



// WEBPACK FOOTER //
// ./src/app/admin/lookup-management/post/post.component.ts